module.exports = __webpack_public_path__ + "src/img/index_menu/blue/1.png?ddc4c8c4e058f10c4f3b1b6f566caa42";


//////////////////
// WEBPACK FOOTER
// ./src/img/index_menu/blue/1.png
// module id = 183
// module chunks = 0